export class TaskRemark {
    customerId: number;
    taskId: number;
    remark: string;
    duration: number;
}